var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2026-02-04T07:09:12-6a02de0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["clashofclans-inbox@supercell"]={id:"2026-02-04T07:09:12-6a02de0"};
      